import React from 'react'

const HTMLContent = ({ content }) => (
  <div dangerouslySetInnerHTML={{ __html: content }} />
)

export default HTMLContent



// WEBPACK FOOTER //
// ./components/slices/HTMLContent/index.js